export class SWIC11ManagerRegistration {
    constructor(form) {
        this.$registrationForm = $(form);
        this.isInternalRegistration = JSON.parse(form.dataset.internalRegistration.toLowerCase());
        this.phoneRegExp = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
        this.emailRegExp = /\w+([-+.'\w]+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/gi;
        this.$gmButton = this.$registrationForm.find("#is-gm");
        this.$auButton = this.$registrationForm.find("#is-au");
        this.$gmSection = this.$registrationForm.find("#is-gm-section");
        this.$auSection = this.$registrationForm.find("#is-au-section");
        this.$alreadyRegisteredStore = this.$registrationForm.find("#already-registered-store");
        this.$isGmContactPreferenceDropdown = this.$gmSection.find("#is-gm-prefer");
        this.$isGmName = this.$gmSection.find("#is-gm-your-name");
        this.$isGmPhoneInput = this.$gmSection.find("#is-gm-phone");
        this.$isGmEmailInput = this.$gmSection.find("#is-gm-email");
        this.$isGmContactSubmit = this.$gmSection.find("#is-gm-contact-submit");
        this.$isGmIssue = this.$gmSection.find("#is-gm-issue");
        this.$isAuPositionDropdown = this.$auSection.find("#is-au-manager-position");
        this.$isAuEmailInput = this.$auSection.find("#is-au-manager-email");
        this.$isAuNameInput = this.$auSection.find("#is-au-manager-name");
        this.$isAuContactSubmit = this.$auSection.find("#is-au-contact-submit");
        this.$isAuIssue = this.$auSection.find("#is-au-issue");
        this.$nominateSchoolSection = this.$registrationForm.find("#nominate-school");
        this.$schoolTextInput = this.$nominateSchoolSection.find("#school-input");
        this.$schoolSubmit = this.$nominateSchoolSection.find("#school-submit");
        this.$nominateSchoolIssue = this.$nominateSchoolSection.find("#nominate-school-issue");
        this.$thankYouSection = this.$registrationForm.find("#ty");
        this.$submissionIssue = this.$registrationForm.find("#submission-issue");
        const self = this;
        if (!self.isInternalRegistration == true) {
            this.$selectStoreSection = this.$registrationForm.find("#select-store-section");
            this.$selectStoreChainDropdown = this.$selectStoreSection.find("#select-store-chain");
            this.$selectStoreLocationDropdown = this.$selectStoreSection.find("#select-store");
            this.$submitStoreButton = this.$selectStoreSection.find("#select-store-submit");
            this.$isAuExternalName = this.$auSection.find('#is-au-your-name');
            this.$isAuExternalEmail = this.$auSection.find('#is-au-your-email');
            this.$selectStoreChainDropdown.change(() => {
                let storechainUid = self.$selectStoreChainDropdown.val().toString();
                self.$selectStoreLocationDropdown.empty().val(null).trigger("change");
                window.irep.callApi({
                    url: "/SWIC11/storelocations",
                    type: "GET",
                    data: {
                        publicUid: storechainUid
                    }
                }).done((d) => {
                    for (let location of d.locations) {
                        let newOption = new Option(location.name, location.publicUid, false, false);
                        self.$selectStoreLocationDropdown.append(newOption);
                    }
                    self.$selectStoreLocationDropdown.trigger('change');
                });
            });
            this.$submitStoreButton.click(() => {
                if (parseInt(self.$selectStoreChainDropdown.val().toString()) != 0 && parseInt(self.$selectStoreLocationDropdown.val().toString()) != 0) {
                    self.$selectStoreSection.hide();
                    self.$gmButton.show();
                    self.$auButton.show();
                }
            });
        }
        this.$gmButton.click(() => {
            self.$registrationForm.find('#position-defs').hide();
            self.$gmSection.show();
            self.$auSection.hide();
            self.$alreadyRegisteredStore.hide();
            self.$nominateSchoolSection.hide();
            self.$auButton.find('.radio').removeClass('selected');
            self.$gmButton.find('.radio').addClass('selected');
        });
        this.$auButton.click(() => {
            self.$registrationForm.find('#position-defs').hide();
            self.$auSection.show();
            self.$gmSection.hide();
            self.$alreadyRegisteredStore.hide();
            self.$nominateSchoolSection.hide();
            self.$auButton.find('.radio').addClass('selected');
            self.$gmButton.find('.radio').removeClass('selected');
        });
        this.$isGmContactSubmit.click(() => {
            self.$isGmIssue.hide();
            let contactPreference = self.$isGmContactPreferenceDropdown.val().toString();
            let phone = self.$isGmPhoneInput.val().toString();
            let email = self.$isGmEmailInput.val().toString();
            if (contactPreference === null || contactPreference === "") {
                self.$isGmIssue.show();
                return;
            }
            if (!self.isInternalRegistration === true) {
                let name = self.$isGmName.val().toString();
                if (name === null || name === "" || name.length <= 2 || name.length > 200) {
                    self.$isGmIssue.show();
                    return;
                }
            }
            if (!((phone !== null && phone !== "") || (email !== null && email !== ""))) {
                self.$isGmIssue.show();
                return;
            }
            let phoneRegFailure = phone.match(self.phoneRegExp) == null;
            let emailRegFailure = email.match(self.emailRegExp) == null;
            if ((phone.length > 0 && phoneRegFailure) || (email.length > 0 && emailRegFailure)) {
                self.$isGmIssue.show();
                return;
            }
            self.$gmSection.hide();
            self.$nominateSchoolSection.show();
        });
        this.$isAuContactSubmit.click(() => {
            self.$isAuIssue.hide();
            let position = self.$isAuPositionDropdown.val().toString();
            let name = self.$isAuNameInput.val().toString();
            let email = self.$isAuEmailInput.val().toString();
            if (position === null || position === "") {
                self.$isAuIssue.show();
                return;
            }
            if (name === null || name === "" || name.length <= 2 || name.length > 200) {
                self.$isAuIssue.show();
                return;
            }
            let emailRegFailure = email.match(self.emailRegExp) == null;
            if (email === null || email === "" || emailRegFailure) {
                self.$isAuIssue.show();
                return;
            }
            if (!self.isInternalRegistration == true) {
                let myName = self.$isAuExternalName.val().toString();
                if (myName === null || myName === "" || myName.length <= 2 || myName.length > 200) {
                    self.$isAuIssue.show();
                    return;
                }
                let myEmail = self.$isAuExternalEmail.val().toString();
                let emailRegFailure = myEmail.match(self.emailRegExp) == null;
                if (email === null || email === "" || emailRegFailure) {
                    self.$isAuIssue.show();
                    return;
                }
            }
            self.$auSection.hide();
            self.$nominateSchoolSection.show();
        });
        this.$schoolSubmit.click(() => {
            self.$nominateSchoolIssue.hide();
            let school1 = self.$schoolTextInput.val().toString();
            if (school1 == null || school1.length <= 3) {
                self.$nominateSchoolIssue.show();
                return;
            }
            self.prepareManagerData();
            self.$nominateSchoolSection.hide();
            self.$gmButton.hide();
            self.$auButton.hide();
        });
        this.$registrationForm.find('select').select2({
            minimumResultsForSearch: 30
        });
        $(".select2").click(() => {
            $(".select2-container:not(.select2)").addClass("padding-top--medium");
        });
    }
    prepareManagerData() {
        let storeUid = "";
        let auManagerPosition = "";
        let managerName = "";
        let managerEmail = "";
        let prefersEmail = false;
        let phone = "";
        let email = "";
        let school1 = "";
        let school2 = 0;
        let school3 = 0;
        let position = this.$gmButton.find('.radio').hasClass("selected") ? "GM" : "AU";
        let myName = "";
        let myEmail = "";
        if (this.isInternalRegistration == false) {
            storeUid = this.$selectStoreLocationDropdown.val().toString();
            if (storeUid == null || storeUid == "") {
                return;
            }
            if (position === "AU") {
                myName = this.$isAuExternalName.val().toString();
                myEmail = this.$isAuExternalEmail.val().toString();
            }
            if (position === "GM") {
                managerName = this.$isGmName.val().toString();
            }
        }
        if (position === "AU") {
            managerName = this.$isAuNameInput.val().toString();
            managerEmail = this.$isAuEmailInput.val().toString();
            auManagerPosition = this.$isAuPositionDropdown.val().toString();
        }
        else if (position === "GM") {
            prefersEmail = this.$isGmContactPreferenceDropdown.val().toString() === "true";
            phone = this.$isGmPhoneInput.val().toString();
            managerEmail = this.$isGmEmailInput.val().toString();
        }
        else {
            this.$submissionIssue.show();
            return;
        }
        school1 = this.$schoolTextInput.val().toString();
        this.submitManagerData(storeUid, position, phone, email, myName, myEmail, auManagerPosition, managerName, managerEmail, prefersEmail, school1, school2, school3);
    }
    submitManagerData(storeUid, position, phone, email, myName, myEmail, auManagerPosition, managerName, managerEmail, prefersEmail, school1, school2, school3) {
        let self = this;
        try {
            window.irep.callApi({
                url: "/swic11/managerinfo",
                type: "POST",
                data: {
                    storeUid: storeUid,
                    managerName: managerName,
                    managerEmail: managerEmail,
                    preferemail: prefersEmail,
                    preferphone: !prefersEmail,
                    auManagerPosition: auManagerPosition,
                    position: position,
                    phone: phone,
                    email: email,
                    myName: myName,
                    myEmail: myEmail,
                    school1: school1,
                    school2: school2,
                    school3: school3
                }
            }).done((d) => {
                if (d.success === true) {
                    self.$thankYouSection.show();
                }
                else {
                    self.$submissionIssue.show();
                }
            });
        }
        catch (_a) {
            self.$submissionIssue.show();
        }
    }
}
const c = {};
$(".swic11-manager-registration").each((i, elem) => {
    c[i] = new SWIC11ManagerRegistration(elem);
});
